import { FC, memo, useMemo } from "react";
import { Table, TableColumn } from "@vilocnv/allsetra-core";
import { useTranslation } from "react-i18next";
import { TOTAL_CO2_REPORT_INNER_TABLE_COLUMNS } from "app/data/constants/Reports/totalCo2ReportsConstants";

const customStyles = {
  cells: {
    style: {
      justifyContent: "center"
    }
  }
};

interface TotalCO2ReportFinalDataProps {
  data: any;
  isShowKeyCol?: boolean;
}

const TotalCO2ReportFinalData: FC<TotalCO2ReportFinalDataProps> = ({
  data,
  isShowKeyCol
}) => {
  const { t } = useTranslation(["translation", "tableHeadingsTranslation"]);
  const tableColumns: TableColumn<any>[] = useMemo(
    () => TOTAL_CO2_REPORT_INNER_TABLE_COLUMNS(t, isShowKeyCol),
    []
  );

  return (
    <Table
      columns={tableColumns}
      data={data.data}
      noTableHead={true}
      pagination={false}
      customStyles={customStyles}
      translator={t}
    />
  );
};

export default memo(TotalCO2ReportFinalData);
